import React, { Component } from "react";
import { Spin, message, Table, Modal } from "antd";
import axios from "axios";
import URLs from "../../utils/apis";

export default class Clients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      loading: false,
      listLoader: false,
      client_list: [],

      add_modal_status: false,
      client_name: "",
      client_image: "",
      formloader: false,

      client_id: 0,
      edit_modal_status: false,
      edit_client_name: "",
      edit_client_image: "",
      client_image_url: "",
      is_image_present: false,

      delete_modal_status: false,
    };
  }
  componentDidMount() {
    this.get_client_list();
    this.get_client_settings();
  }
  get_client_settings = () => {
    this.setState({ listLoader: true });
    axios
      .get(URLs.get_client_settings)
      .then((response) => {
        if (response.data.status == "1") {
          this.setState({
            title: response.data.data.title,
            listLoader: false,
          });
        } else {
          this.setState({ listLoader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ listLoader: false });
      });
  };
  save_client_settings = () => {
    this.setState({ listLoader: true });
    let params = {
      title: this.state.title,
    };
    axios
      .post(URLs.save_client_settings, params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              listLoader: false,
            },
            () => this.get_client_settings()
          );
        } else {
          this.setState({ listLoader: false });
          message.warning(response.data.message);
          return;
        }
      })
      .catch((error) => {
        this.setState({ listLoader: false });
      });
  };
  get_client_list = () => {
    this.setState({ listLoader: true });
    axios
      .get(URLs.get_client_list)
      .then((response) => {
        if (response.data.status == "1") {
          let currentObj = response.data.data;
          this.setState({
            client_list: response.data.data,
            listLoader: false,
          });
        } else {
          this.setState({ listLoader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ listLoader: false });
      });
  };
  save_client = () => {
    if (!this.state.client_name) {
      message.warning("Client name is required");
      return;
    }
    if (!this.state.client_image) {
      message.warning("Please select client image");
      return;
    }
    this.setState({ formloader: true });
    let formData = new FormData();
    formData.append("name", this.state.client_name);
    formData.append("client_image", this.state.client_image);
    axios
      .post(URLs.save_client, formData)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              formloader: false,
              client_name: "",
              client_image: "",
              add_modal_status: false,
            },
            () => this.get_client_list()
          );
        } else {
          message.warning(response.data.message);
          this.setState({ formloader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ formloader: false });
        console.error("Warning:", error);
        // message.warning("Please try again.");
      });
  };
  open_add_modal = () => {
    this.setState({
      add_modal_status: true,
      client_name: "",
      client_image: "",
    });
  };
  close_save_modal = () => {
    this.setState({
      add_modal_status: false,
      client_name: "",
      client_image: "",
    });
  };
  open_edit_modal = (item) => {
    let url = URLs.image_url + item.image;
    this.setState({
      edit_modal_status: true,
      edit_client_name: item.name,
      client_image_url: url,
      client_id: item.client_id,
      is_image_present: item.image ? true : false,
    });
  };
  close_update_modal = () => {
    this.setState({
      edit_modal_status: false,
      edit_service_name: "",
      edit_service_description: "",
      client_image_url: "",
      client_id: "",
      is_image_present: false,
      is_icon_image_present: false,
    });
  };
  update_client = () => {
    if (!this.state.edit_client_name) {
      message.warning("Client name is required");
      return;
    }
    this.setState({ formloader: true });
    let formData = new FormData();
    formData.append("name", this.state.edit_client_name);
    formData.append("client_image", this.state.edit_client_image);
    formData.append("client_id", this.state.client_id);
    axios
      .post(URLs.update_client, formData)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              formloader: false,
              edit_client_name: "",
              edit_client_image: "",
              edit_modal_status: false,
              client_id: 0,
            },
            () => this.get_client_list()
          );
        } else {
          message.warning(response.data.message);
          this.setState({ formloader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ formloader: false });
        console.error("Warning:", error);
      });
  };
  close_delete_modal = () => {
    this.setState({
      delete_modal_status: false,
      client_id: "",
    });
  };
  open_delete_modal = (item) => {
    this.setState({
      delete_modal_status: true,
      client_id: item.client_id,
    });
  };
  delete_client = () => {
    let params = {
      client_id: this.state.client_id,
    };
    axios
      .post(URLs.delete_client, params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              formloader: false,
              delete_modal_status: false,
              client_id: 0,
            },
            () => this.get_client_list()
          );
        } else {
          message.warning(response.data.message);
          this.setState({ formloader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ formloader: false });
        console.error("Warning:", error);
      });
  };
  render() {
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 150,
      },
      {
        title: "Image",
        dataIndex: "img",
        key: "img",
        render: (item) => {
          let url = URLs.image_url + item.image;
          return (
            <div>
              <img src={url} style={{ maxWidth: 100 }} />
            </div>
          );
        },
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        render: (item) => {
          return (
            <div>
              <button
                type="button"
                onClick={() => this.open_edit_modal(item)}
                class="btn btn-primary mb-3"
                style={{ width: 50, height: 35, marginRight: 10 }}
              >
                <box-icon
                  name="edit-alt"
                  color="#ffffff"
                  size={"18px"}
                ></box-icon>
              </button>
              <button
                type="button"
                onClick={() => this.open_delete_modal(item)}
                class="btn btn-danger mb-3"
                style={{ width: 50, height: 35 }}
              >
                <box-icon name="trash" color="white" size={"18px"}></box-icon>
              </button>
            </div>
          );
        },
      },
    ];
    const dataSource = this.state.client_list.map((item, index) => {
      return {
        name: item.name ? item.name : "---",
        img: item,
        action: item,
      };
    });
    return (
      <div class="card">
        <div class="card-header">
          <h4 class="card-title" style={{ fontSize: 16, marginBottom: 0 }}>
            Client List
          </h4>
        </div>
        <Spin spinning={this.state.loading}>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-lg-12">
                <div>
                  <div class="mb-3">
                    <label for="example-text-input" class="form-label">
                      Title <span class="text-danger">*</span>
                    </label>
                    <input
                      class="form-control"
                      type="text"
                      value={this.state.title}
                      onChange={(e) => this.setState({ title: e.target.value })}
                    />
                  </div>
                  <div class="mt-4">
                    <button
                      type="button"
                      onClick={() => this.save_client_settings()}
                      class="btn btn-primary w-md"
                    >
                      Update
                    </button>
                  </div>
                </div>
                <div class="card mt-3 p-3">
                  <button
                    type="button"
                    onClick={() => this.open_add_modal()}
                    class="btn btn-primary mb-3"
                    style={{ width: 180, float: "right", marginLeft: "auto" }}
                  >
                    Add New Client
                  </button>
                  <Table
                    bordered
                    loading={this.state.listLoader}
                    dataSource={dataSource}
                    columns={columns}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>

        {/* Add Service Modal  */}
        <Modal
          title="Add New Client"
          visible={this.state.add_modal_status}
          onOk={() => this.save_client()}
          onCancel={() => this.close_save_modal()}
          okText="Save"
          cancelText="Cancel"
        >
          <Spin spinning={this.state.formloader}>
            <div class="py-4">
              <div class="mb-3">
                <label for="example-text-input" class="form-label">
                  Name <span class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  type="text"
                  value={this.state.client_name}
                  onChange={(e) =>
                    this.setState({ client_name: e.target.value })
                  }
                />
              </div>
              <div class="mb-3">
                <label for="example-text-input" class="form-label">
                  Client Image <span class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  type="file"
                  onChange={(e) =>
                    this.setState({ client_image: e.target.files[0] })
                  }
                />
              </div>
            </div>
          </Spin>
        </Modal>

        {/* Edit Service Modal  */}
        <Modal
          title="Update Client"
          visible={this.state.edit_modal_status}
          onOk={() => this.update_client()}
          onCancel={() => this.close_update_modal()}
          okText="Update"
          cancelText="Cancel"
        >
          <Spin spinning={this.state.formloader}>
            <div class="py-4">
              <div class="mb-3">
                <label for="example-text-input" class="form-label">
                  Name <span class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  type="text"
                  value={this.state.edit_client_name}
                  onChange={(e) =>
                    this.setState({ edit_client_name: e.target.value })
                  }
                />
              </div>
              <div class="mb-3">
                <label for="example-text-input" class="form-label">
                  Image <span class="text-danger">*</span>
                </label>
                {this.state.is_image_present == true && (
                  <div
                    style={{
                      padding: 10,
                      border: "1px solid #ddd",
                      width: "fit-content",
                    }}
                    class="mb-2"
                  >
                    <a href={this.state.client_image_url} target="_blank">
                      <img
                        src={this.state.client_image_url}
                        style={{ width: 100 }}
                      />
                    </a>
                  </div>
                )}
                <input
                  class="form-control"
                  type="file"
                  onChange={(e) =>
                    this.setState({ edit_client_image: e.target.files[0] })
                  }
                />
              </div>
            </div>
          </Spin>
        </Modal>

        <Modal
          title="Delete Client"
          visible={this.state.delete_modal_status}
          onOk={() => this.delete_client()}
          onCancel={() => this.close_delete_modal()}
          okText="Delete"
          cancelText="Cancel"
        >
          <Spin spinning={this.state.formloader}>
            <div class="pt-4">
              <p style={{ fontSize: 16 }}>Are you sure you want to delete?</p>
            </div>
          </Spin>
        </Modal>
      </div>
    );
  }
}
